import request from '@/utils/request'

// 查询登录日志列表
export function list (query) {
  return request({
    url: '/biz/admin/monitor/logininfor/list',
    method: 'get',
    params: query
  })
}

// 删除登录日志
export function delLogininfor (infoId) {
  return request({
    url: '/biz/admin/monitor/logininfor/' + infoId,
    method: 'delete'
  })
}

// 清空登录日志
export function cleanLogininfor () {
  return request({
    url: '/biz/admin/monitor/logininfor/clean',
    method: 'delete'
  })
}

// 解锁用户登录状态
export function unlockLogininfor (userName) {
  return request({
    url: '/biz/admin/monitor/logininfor/unlock/' + userName,
    method: 'get'
  })
}
